import React, { useEffect, useState } from 'react';
import { NextSeo } from 'next-seo';

import Header from '../../components/enfusion/Header';
import Footer from '../../components/enfusion/Footer';
import { useAppContext } from '../../util/context';

import { flatListToHierarchical } from '../../util/wordpress';

import Posts from './posts';
import Sidebar from './sidebar';
import AwardsHeader from './header';

const AwardsLayout = ({ pageProps = {} }) => {
    const { awards, nextSeoProps } = pageProps;

    const context = useAppContext();
    context.toggleDarkMode(false);
    context.toggleHeaderTheme('bg-white');

    // Filter post function based on category selection
    const [filterCategories, setFilterCategories] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const resetFilterCategories = () => setFilterCategories([]);

    function filterPosts(slug) {
        const index = filterCategories.indexOf(slug);

        if (index === -1) {
            setFilterCategories([...filterCategories, slug]);
        } else {
            const copy = [...filterCategories];
            copy.splice(index, 1);

            setFilterCategories(copy);
        }
    }

    return (
        <>
            <NextSeo {...nextSeoProps} />
            <Header {...pageProps} />

            <main className="text-purple-midnight">
                <AwardsHeader title="Earning the respect of our peers." />
                <div className="container pb-24">
                    <div className="relative justify-between lg:flex">
                        <div className="w-full lg:max-w-[224px]">
                            <Sidebar
                                filterPosts={filterPosts}
                                categories={awards?.awardtypes?.nodes}
                                regions={awards?.regions?.nodes}
                                setSearchQuery={setSearchQuery}
                                resetFilterCategories={resetFilterCategories}
                                filterCategories={filterCategories}
                            />
                        </div>
                        <div className="w-full lg:max-w-[830px] pl-0 xl:pl-0 lg:pl-6">
                            <Posts
                                filterCategories={filterCategories}
                                awards={awards?.contentNodes?.nodes}
                                searchQuery={searchQuery}
                                setSearchQuery={setSearchQuery}
                            />
                        </div>
                    </div>
                </div>
            </main>

            <Footer {...pageProps} />
        </>
    );
};

export default AwardsLayout;
